export default __webpack_public_path__ + "static/media/sound.89452084.mp3";